import { api } from "./api";

/**
 * Admin product CRUD (Phase A11 refresh).
 *
 * The core CRUD is JSON-only now. Multi-image uploads go through the
 * dedicated `/images` sub-endpoints (multipart), so the primary create/
 * patch calls no longer carry the image binary.
 */
export const adminProductsService = {
  create: (fields) =>
    api.post("/admin/products", fields).then((r) => r.data),

  update: (id, fields) =>
    api.patch(`/admin/products/${id}`, fields).then((r) => r.data),

  remove: (id) => api.delete(`/admin/products/${id}`).then((r) => r.status),

  appendImage: (id, file) => {
    const fd = new FormData();
    fd.append("image", file);
    return api
      .post(`/admin/products/${id}/images`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  deleteImage: (id, index) =>
    api.delete(`/admin/products/${id}/images/${index}`).then((r) => r.data),
};
